import { useMemo } from "react";

import { useGetOrientationCredentials } from "./useGetOrientationCredentials";

/**
 * Returns the set of workplace IDs where the worker already has an orientation credential.
 *
 * Used to determine whether a shift at a workplace should be displayed as a
 * pre-shift orientation shift — workers who already hold a credential for a
 * workplace do not need to arrive early for orientation.
 */
export function useWorkplacesWithOrientationCredentials(): {
  workplacesWithOrientationCredentials: Set<string>;
  isLoading: boolean;
  isError: boolean;
} {
  const { data, isLoading, isError } = useGetOrientationCredentials();

  const workplacesWithOrientationCredentials = useMemo(
    () =>
      new Set((data?.data ?? []).map((credential) => credential.relationships.workplace.data.id)),
    [data?.data]
  );

  return {
    workplacesWithOrientationCredentials,
    isLoading,
    isError,
  };
}
